/* globals mixpanel */

import {reportType} from './common';

function anomalyTimeUnit(alert) {
  const {funnelsQuery, insightsQuery, retentionQuery} = alert.anomaly;
  if (insightsQuery) {
    return insightsQuery.timeUnit;
  } else if (funnelsQuery) {
    return funnelsQuery.timeUnit;
  } else if (retentionQuery) {
    return retentionQuery.timeUnit;
  }
}

function anomalyDetails(anomaly) {
  return anomaly.anomalyDetail ? [anomaly.anomalyDetail] : anomaly.anomalyDetails;
}

export const anomalies = {
  anomaly_detail_ids: (alert) => anomalyDetails(alert.anomaly).map((ad) => ad.anomalyDetailId),
  time_unit: (alert) => anomalyTimeUnit(alert),
  insights_show_actions: (alert) => {
    const {anomaly} = alert;
    if (!anomaly.insightsQuery) {
      return null;
    }

    return anomalyDetails(anomaly).map((ad) => ad.insightsDetails.showAction);
  },
};

function contourDetails(contour) {
  return contour.contourDetail ? [contour.contourDetail] : contour.contourDetails;
}

export const contours = {
  contour_detail_ids: (alert) => contourDetails(alert.contour).map((ad) => ad.contourDetailId),
  score: (alert) => {
    if (alert.contour.contourDetail) {
      return alert.contour.contourDetail.score;
    } else {
      return null;
    }
  },
  property: (alert) => alert.contour.property,
};

export const commonProps = {
  alert_id: (alert) => alert.alertId,
  alert_type: (alert) => {
    const {anomaly, contour} = alert;
    if (anomaly) {
      return `ANOMALY`;
    } else if (contour) {
      return `CONTOUR`;
    }
  },
  detection_reason: (alert) => alert.detectionReason,
  report_type: (alert) => reportType(alert).toUpperCase(),
};

function transform(mapping, item, output) {
  return Object.keys(mapping).forEach((k) => (output[k] = mapping[k](item)));
}

export function trackAlertEvent(eventName, alert, context, extraProps = {}) {
  return new Promise((resolve) => {
    mixpanel.track(
      eventName,
      {
        ...alert.trackingProperties,
        alert_view: context.alertView,
        display_context: context.displayContext,
        ...extraProps,
      },
      resolve,
    );
  });
}

export function trackingProperties(alert) {
  const props = {};
  transform(commonProps, alert, props);

  if (alert.contour) {
    transform(contours, alert, props);
  } else {
    transform(anomalies, alert, props);
  }

  return props;
}
